var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.0654 8.06641V18.3677L30.9305 22.2583L22.0654 8.06641Z",
    fill: "#454A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.0665 8.06641L13.2002 22.2583L22.0665 18.3677V8.06641Z",
    fill: "#454A75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.0654 28.9332V35.9327L30.9364 23.8789L22.0654 28.9332Z",
    fill: "#454A75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.0665 35.9327V28.932L13.2002 23.8789L22.0665 35.9327Z",
    fill: "#454A75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0654 27.3148L30.9305 22.2594L22.0654 18.3711V27.3148Z",
    fill: "#454A75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.2002 22.2594L22.0665 27.3148V18.3711L13.2002 22.2594Z",
    fill: "#454A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereum-logo.1b06fad3960634fb337966974b774d36.svg";
export { ForwardRef as ReactComponent };